import React from 'react';

interface TikTokIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  /** When true, renders the official multicolor TikTok mark (cyan/magenta/white). Default monochrome. */
  colored?: boolean;
}

/**
 * TikTok logo. Lucide does not ship a TikTok glyph, so we provide a dedicated
 * SVG component that follows the same visual contract as Lucide icons
 * (currentColor, sizing via `size`/`className`).
 */
export const TikTokIcon = React.forwardRef<SVGSVGElement, TikTokIconProps>(
  ({ size = 24, colored = false, className, ...props }, ref) => {
    if (colored) {
      return (
        <svg
          ref={ref}
          width={size}
          height={size}
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          {...props}
        >
          <path
            d="M33.5 8.5c.6 3.6 2.7 6.1 6.5 6.7v4.4c-2.8 0-5.2-.9-7.4-2.6v11.4c0 7-5.7 12.6-12.6 12.6S7.4 35.4 7.4 28.4 13 15.8 19.9 15.8c.7 0 1.4 0 2.1.2v4.7c-.7-.2-1.4-.3-2.1-.3-4.3 0-7.8 3.5-7.8 7.9s3.5 7.9 7.8 7.9 7.8-3.5 7.8-7.9V8.5h5.8z"
            fill="#25F4EE"
            transform="translate(-2,-2)"
          />
          <path
            d="M35.5 10.5c.6 3.6 2.7 6.1 6.5 6.7v4.4c-2.8 0-5.2-.9-7.4-2.6v11.4c0 7-5.7 12.6-12.6 12.6S9.4 37.4 9.4 30.4 15 17.8 21.9 17.8c.7 0 1.4 0 2.1.2v4.7c-.7-.2-1.4-.3-2.1-.3-4.3 0-7.8 3.5-7.8 7.9s3.5 7.9 7.8 7.9 7.8-3.5 7.8-7.9V10.5h5.8z"
            fill="#FE2C55"
            transform="translate(2,2)"
          />
          <path
            d="M34.5 9.5c.6 3.6 2.7 6.1 6.5 6.7v4.4c-2.8 0-5.2-.9-7.4-2.6v11.4c0 7-5.7 12.6-12.6 12.6S8.4 36.4 8.4 29.4 14 16.8 20.9 16.8c.7 0 1.4 0 2.1.2v4.7c-.7-.2-1.4-.3-2.1-.3-4.3 0-7.8 3.5-7.8 7.9s3.5 7.9 7.8 7.9 7.8-3.5 7.8-7.9V9.5h5.8z"
            fill="currentColor"
          />
        </svg>
      );
    }
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.5a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.93z" />
      </svg>
    );
  }
);
TikTokIcon.displayName = 'TikTokIcon';

export default TikTokIcon;